// 文件相关API接口
import request from '@/utils/request'
// 向外按需导出一个API函数
/**
 * 上传文件
 * @param data
 * type 分3类
 * 1、thumbnailsimgs 非工程案例的文章缩略图
 * 2、housekeepers 明星管家图片
 * 3、articleimgs  文章里图片
 * 4、articleproject 工程案例缩略图
 * @returns {*}
 */
export function fileUp(data) {
    return request({
        url: '/upload/uploadimgs',
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

/**
 * 删除记录
 * @param id
 * @returns {*}
 */
export function delArticle(id,type) {
    return request({
        url: '/articles/'+type+'/'+id,
        method: 'delete'
    })
}

/**
 * 公司动态\安全须知\行业资讯\厂家广告\维保指南\滚动消息
 * （管）分页记录
 * @param params
 * @param data
 * @returns {*}
 */
export function articlesPage(params,data) {
    return request({
        url: '/articles/'+data.type+'/manage/page',
        method: 'post',
        data,
        params
    })
}

/**
 * 获取单页文章
 * @param type
 * @returns {*}
 */
export function articlesSingle(type) {
    return request({
        // url: '/articles/singlepage/public/'+type, 220525修改为下面地址
        url: '/articles/'+type+'/singlepage',
        method: 'get'
    })
}
/**
 * 获取单页文章带token
 * @param type
 * @returns {*}
 */
export function articlesSingleToken(type,token) {
    return request({
        url: '/articles/'+type+'/singlepage',
        method: 'get',
        headers: {
            'token': 'Bearer '+token
        }
    })
}
/**
 * 添加单页文章
 * 会员权益\到家服务\服务政策\明星管家\用户协议\隐私政策
 * @param data
 * @returns {*}
 */
export function addArticlesSingle(data) {
    return request({
        url: '/articles/'+data.type+'/singlepage',
        method: 'post',
        data
    })
}
/**
 * 编辑单页文章
 * 会员权益\到家服务\服务政策\明星管家\用户协议\隐私政策
 * @param data
 * @returns {*}
 */
export function updateArticlesSingle(data) {
    return request({
        url: '/articles/'+data.type+'/singlepage',
        method: 'put',
        data
    })
}
/**
 * 添加记录
 * 公司动态\安全须知\行业资讯\厂家广告\维保指南\滚动消息
 * @param data
 * @returns {*}
 */
export function addArticles(data) {
    return request({
        url: '/articles/'+data.type,
        method: 'post',
        data
    })
}
/**
 * 更新记录
 * 公司动态\安全须知\行业资讯\厂家广告\维保指南\滚动消息
 * @param data
 * @returns {*}
 */
export function updateArticles(data) {
    return request({
        url: '/articles/'+data.type,
        method: 'put',
        data
    })
}
/**
 * 工程案例
 * 分页记录
 * @param params
 * @param data
 * @returns {*}
 */
export function articleProjectsPage(params,data) {
    return request({
        url: '/articleprojects/manage/page',
        method: 'post',
        data,
        params
    })
}
/**
 * 添加工程案例记录
 * @param data
 * @returns {*}
 */
export function addArticleProjects(data) {
    return request({
        url: '/articleprojects',
        method: 'post',
        data
    })
}
/**
 * 更新工程案例记录
 * @param data
 * @returns {*}
 */
export function updateArticleProjects(data) {
    return request({
        url: '/articleprojects',
        method: 'put',
        data
    })
}
/**
 * 删除工程案例记录
 * @param id
 * @returns {*}
 */
export function delArticleProjects(id) {
    return request({
        url: '/articleprojects/'+id,
        method: 'delete'
    })
}

/**
 * 查找某篇工程案例
 * @param id
 * @returns {*}
 */
export function getArticleProjects(id,token) {
    return request({
        url: '/articleprojects/'+id,
        method: 'get',
        headers: {
            'token': 'Bearer '+token
        }
    })
}
/**
 * 查找某篇文章
 * @param id
 * @returns {*}
 */
export function getArticleById(id,type,token) {
    return request({
        url: '/articles/'+type+'/'+id,
        method: 'get',
        headers: {
            'token': 'Bearer '+token
        }
    })
}

/**
 * 文章推送-分页记录
 * @param params
 * @param data
 * @returns {*}
 */
export function articlePushPage(params,data) {
    return request({
        url: '/articlepush/'+data.type+'/page',
        method: 'post',
        data,
        params
    })
}
/**
 * 文章-知识推送
 * @param params
 * @param data
 * @returns {*}
 */
export function articlePush(article_id) {
    return request({
        url: '/articlepush/push/'+article_id,
        method: 'post'
    })
}
